<template>
  <div
    :class="[classes, joinClasses('notice', modifiers)]"
    role="alert"
  >
    <component
      :is="iconType"
      v-if="showIcon"
      :id="`icon_${iconStyle}`"
      aria-label="icon"
      class="notice__icon"
    />
    <div class="notice__message typo-small">
      {{ message }}
      <slot />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import joinClasses from '@/functions/join_classes';

// Icons
import iEncircledIcon from '@/images/i_encircled.svg';
import ExclamationTriangleIcon from '@/images/exclamation-triangle.svg';

const props = defineProps({
  /** Message displayed to the user */
  message: { type: String, required: false, default: null },
  /** Additional classes you may add */
  modifiers: { type: Array, default: () => [] },
  /** Show/hide the border */
  withBorder: { type: Boolean, required: false, default: true },
  /** Show/hide the icon */
  showIcon: { type: Boolean, required: false, default: true },
  /** The icon to be used in the notice */
  iconStyle: {
    type: String,
    required: false,
    default: null,
    validator(value) {
      return ['warning', 'info'].includes(value);
    },
  },
  /** The color style of the notice */
  colorStyle: {
    type: String,
    required: false,
    default: null,
    validator(value) {
      return ['warning', 'info'].includes(value);
    },
  },

});

const iconType = computed(() => {
  switch (props.iconStyle) {
    case 'warning':
      return ExclamationTriangleIcon;
      case 'info':
      return iEncircledIcon;
    default:
      return null;
  }
});

const classes = computed(() => {
  return {
    'notice': true,
    'notice--type-warning': props.colorStyle === 'warning',
    'notice--type-info': props.colorStyle === 'info',
    'notice--type-default': !props.colorStyle,
    'notice--no-border': !props.withBorder,
  };
});
</script>
